export const SET_EDITED_NINJA_PAGE_ID = "SET_EDITED_NINJA_PAGE_ID";
export const SET_NINJA_QUESTIONS = "SET_NINJA_QUESTIONS";
export const SET_NINJA_MASTER_FLAG = "SET_NINJA_MASTER_FLAG";
export const SET_NINJA_DOCUMENT_ID = "SET_NINJA_DOCUMENT_ID";
export const SET_NINJA_DOCUMENT_LANG = "SET_NINJA_DOCUMENT_LANG";
export const SET_NINJA_INTRO = "SET_NINJA_INTRO";
